export default theme => ({
  data: {
    marginTop: theme.sizes[3],
  },
  livestream_actions_container: {
    paddingBottom: 0,
    marginBottom: -28,
  },
  livestream__status: {
    color: theme.palette.primary.dark,
    border: `1px solid ${theme.palette.primary.dark}`,
    float: "right",
    marginTop: 10,
    marginRight: 5,
  },
  livestream__actions: {
    float: "right",
    marginTop: 2,
  },
  deleted: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
  },
  deleted__text: {
    color: `${theme.palette.secondary.main}`,
    fontWeight: "normal !important",
    fontSize: "inherit !important",
  },
  deleted__status: {
    border: `1px solid ${theme.palette.secondary.main}`,
  },
});
